import { Attributes, Rules, Validation } from '@singularsystems/neo-core';
import TemporalEntity from '../TemporalEntity';

export enum ImportFileType {
    Csv = 1,
    Xlsx = 2,
}

export default class ImportConfig extends TemporalEntity {
    static typeName = "ImportConfig";

    constructor() {
        super();
        this.makeObservable();
    }

    public importConfigId: number = 0;

    public columnHeadings: boolean = true;

    @Rules.StringLength(50)
    @Rules.Required()
    public name: string = "";

    @Attributes.Nullable()
    @Attributes.Integer()
    public rowFilterColumnIndex: number | null = null;

    @Attributes.Nullable()
    @Rules.StringLength(50)
    public rowFilterColumnName: string | null = null;

    @Attributes.Nullable()
    @Attributes.Integer()
    public effectiveDateColumnIndex: number | null = null;

    @Attributes.Nullable()
    @Rules.StringLength(50)
    public effectiveDateColumnName: string | null = null;

    @Attributes.Nullable()
    @Attributes.Integer()
    public interestRateColumnIndex: number | null = null;

    @Attributes.Nullable()
    @Rules.StringLength(50)
    public interestRateColumnName: string | null = null;

    public importFileType: ImportFileType = ImportFileType.Csv;

    @Attributes.Nullable()
    @Rules.StringLength(1)
    public delimiter: string | null = null;

    public automatedImport: boolean = false;

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<ImportConfig>) {
        super.addBusinessRules(rules);

        rules.failWhen(ic => ic.importFileType === ImportFileType.Csv && (ic.delimiter == null || ic.delimiter.length === 0), "Delimiter is required when file type is CSV.").onProperties(c => c.delimiter);
        rules.failWhen(ic => (ic.interestRateColumnName == null || ic.interestRateColumnName.length === 0) && ic.interestRateColumnIndex == null, "Rate column name or index is required.").onProperties(c => [c.interestRateColumnIndex, c.interestRateColumnName]);
        rules.failWhen(ic => (ic.effectiveDateColumnName == null || ic.effectiveDateColumnName.length === 0) && ic.effectiveDateColumnIndex == null, "Date column name or index is required.").onProperties(c => [c.effectiveDateColumnIndex, c.effectiveDateColumnName]);
        rules.failWhen(ic => !ic.columnHeadings && ic.interestRateColumnIndex == null, "Rate index is required.").onProperties(c => c.interestRateColumnIndex);
        rules.failWhen(ic => !ic.columnHeadings && ic.effectiveDateColumnIndex == null, "Date index is required.").onProperties(c => c.effectiveDateColumnIndex);
        rules.failWhen(ic => ic.effectiveDateColumnIndex != null && ic.effectiveDateColumnIndex <= 0, "Date index must be a positive integer.");
        rules.failWhen(ic => ic.interestRateColumnIndex != null && ic.interestRateColumnIndex <= 0, "Rate index must be a positive integer.");
        rules.failWhen(ic => ic.rowFilterColumnIndex != null && ic.rowFilterColumnIndex <= 0, "Filter index must be a positive integer.");
    }

    public toString(): string {
        if (this.isNew || !this.name) {
            return "New import config";
        } else {
            return this.name;
        }
    }
}